import gql from 'graphql-tag'

export default gql`mutation checkedBib($filter:FilterFindOneParticipantInput){
    checkedBib(filter:$filter){
      eventId
    }
  }`
